import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {GlossaryInfoModal} from 'shells/glossary-info-modal/glossary-info-modal';
import {Illustration} from 'shells/illustrations/illustration';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

export function BroadcastInfoModal() {
    const {onClose} = useOpenableModal(OpenableModals.BROADCAST_INFO_MODAL);

    return (
        <GlossaryInfoModal
            onClose={onClose}
            artImage={<Illustration src='email-message' />}
            title='What are broadcasts?'
            body={
                <p>
                    <BulletedList
                        bullets={[
                            <span key='bullet-1'>
                                Use a broadcast to make an announcement or inform an audience of
                                something
                            </span>,
                            <span key='bullet-2'>
                                Write and design your messages with the drag-and-drop editor or get
                                a quick start with a template
                            </span>,
                            <span key='bullet-3'>
                                Send beautifully designed messages to thousands of people at a time
                            </span>,
                        ]}
                    />
                </p>
            }
            learnEvenMoreHref='https://support.nutshell.com/en/articles/8428867-campaigns-how-to-create-email-broadcasts'
        />
    );
}
